import type { ReactNode, JSX} from "react";
import { PillButton } from "./PillButton";

export interface ChatComposerProps {
  readonly placeholder: string;
  readonly modePills?: readonly string[];
  readonly attachButton?: ReactNode;
  readonly activePillIndex?: number;
}

/**
 * Chat input bar with optional mode pills and attach button.
 * Used in inbox module and agent module.
 */
export function ChatComposer({
  placeholder,
  modePills,
  attachButton,
  activePillIndex = 0,
}: ChatComposerProps): JSX.Element {
  return (
    <div className="border-t border-edge bg-surface-secondary sticky bottom-0">
      {modePills && modePills.length > 0 && (
        <div className="flex gap-2 px-5 pt-2.5">
          {modePills.map((pill, index) => (
            <PillButton key={pill} active={index === activePillIndex}>
              {pill}
            </PillButton>
          ))}
        </div>
      )}
      <div className="flex items-center gap-3 px-5 pb-4 pt-2">
        {attachButton}
        <input
          className="flex-1 h-10 bg-surface-hover border border-edge rounded-[10px] px-3.5 text-sm text-content placeholder:text-content-tertiary"
          placeholder={placeholder}
          aria-label={placeholder}
        />
        <button
          className="w-9 h-9 rounded-full border-none bg-accent text-white cursor-pointer inline-flex items-center justify-center transition-all duration-[180ms] hover:bg-accent-hover hover:-translate-y-px"
          type="button"
        >
          ▶
        </button>
      </div>
    </div>
  );
}
